window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.HomeAnimation = (function HomeAnimation() {

  'use strict';

  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const homeAnimation = document.querySelector('.hero-animation-zone');


    if (homeAnimation) {
      const images = homeAnimation.querySelectorAll('.animation-image');


      function imageSlider(param) {

        let transformValue = param.style.transform || 0;

        if (transformValue) {
          transformValue = parseInt(transformValue.substring(11, transformValue.indexOf('px')));
        } else {
          if (param.classList.contains('is-active')) {
            transformValue = 0;
          } else {
            const activeImage = homeAnimation.querySelector('.animation-image.is-active');
            transformValue = activeImage.getBoundingClientRect().right - (window.innerWidth * .25) + 100;
          }
        }

        transformValue -= 5;
        param.style.transform = `translateX(${transformValue}px)`;

        if (param.classList.contains('is-active')) {
          const rightPosition = param.getBoundingClientRect().right;
          if (rightPosition < 0) {
            const nextActiveImage = homeAnimation.querySelector('.animation-image:not(.is-active)')
            nextActiveImage.classList.add('is-active');
            param.classList.remove('is-active');
            param.classList.add('is-hidden');

            transformValue = nextActiveImage.getBoundingClientRect().right - (window.innerWidth * .25) + 100;
            param.style.transform = `translateX(${transformValue}px)`;

            setTimeout(() => {
              param.classList.remove('is-hidden');
            }, 1000);
          }
        }

      }

      images.forEach(image => {

        setInterval(() => {
          imageSlider(image);
        }, 50)

      });

      // window.addEventListener('resize', () => {
      //   images.forEach(image => {
      //
      //     setInterval(() => {
      //       imageSlider(image);
      //     }, 50)
      //
      //   });
      // });

    }



    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
